<div class="container">


  <app-header-dialog [iconName]="'supervised_user_circle'">
    {{memberGN1.name}}
  </app-header-dialog>

  <div class="content">

    <div style="box-sizing: content-box; display:flex; flex-direction: row; justify-content: space-between;">

      <div style="width: 50%; margin: 10px; padding: 20px; background-color: rgba(10,10,10,.05);">

        <h4>GN1</h4>

        <mat-form-field class="full-width">
          <input matInput type="text" [formControl]="memberFormGN1.controls.name" placeholder="Nome" autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.name.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.category_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.category" placeholder="Categoria"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.category.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.situation_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.situation" placeholder="Situação"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.situation.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.email_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.email" placeholder="Email"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.email.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.email2_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.email2" placeholder="Email2"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.email2.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.gender_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.gender" placeholder="Gênero"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.gender.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.filiationDate_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.filiationDate" placeholder="Data Filiação"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.filiationDate.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.birthDate_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.birthDate" placeholder="Data Nasc."
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.birthDate.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.titleDate_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.titleDate" placeholder="Data Título"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.titleDate.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.cpf_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.cpf" placeholder="CPF" autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.cpf.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.rg_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.rg" placeholder="RG" autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.rg.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.crm_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.crm" placeholder="CRM" autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.crm.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.cellPhone_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.cellPhone" placeholder="Celular"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.cellPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.faxPhone_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.faxPhone" placeholder="FAX"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.faxPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.clinicPhone_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.clinicPhone" placeholder="Clínica"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.clinicPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.hospitalPhone_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.hospitalPhone" placeholder="Hospital"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.hospitalPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.auxPhone1_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.auxPhone1" placeholder="Auxiliar 1"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.auxPhone1.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.auxPhone2_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.auxPhone2" placeholder="Auxiliar 2"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.auxPhone2.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.regional_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.regional" placeholder="regional"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.regional.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.state_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.state" placeholder="Estado"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.state.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.city_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.city" placeholder="Cidade"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.city.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.district_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.district" placeholder="Bairro"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.district.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.address_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.address" placeholder="Rua/Av"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.address.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.number_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.number" placeholder="Número"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.number.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.complement_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.complement" placeholder="Complemento"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.complement.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.postalCode_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.postalCode" placeholder="CEP"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.postalCode.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.institute_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.institute" placeholder="Residência"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.institute.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.institute_begin_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.institute_begin" placeholder="Início"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.institute_begin.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.institute_end_ok }">
          <input matInput type="text" [formControl]="memberFormGN1.controls.institute_end" placeholder="Término"
            autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.institute_end.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <!--
        
        <mat-form-field class="full-width">
          <input matInput type="text"
            [formControl]="memberFormGN1.controls.specialization" placeholder="Especialização" autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.specialization.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <input matInput type="text" [formControl]="memberFormGN1.controls.concilState"
            placeholder="Conselho" autocomplete="off">
          <mat-error *ngIf="memberFormGN1.controls.concilState.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>




        <div style="padding: 20px 0 20px 0;">
          <mat-checkbox color='primary' [formControl]="memberFormGN1.controls.exclude">
            <span>Excluído</span>
          </mat-checkbox>
        </div>

        -->

        <div class="actions">
          <button mat-raised-button (click)="matDialogRef.close(['okGN1',memberFormGN1])"
            [disabled]="memberFormGN1.invalid">
            GN1 <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </div>

      <div style="width: 50%; margin: 10px; padding: 20px; background-color: rgba(10,10,10,.02);"
        *ngIf="memberFormSBCCV">

        <h4>SBCCV</h4>

        <mat-form-field class="full-width">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.name" placeholder="Nome"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.name.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.category_ok }">
          <input readonly matInput type="text" [formControl]="memberFormSBCCV.controls.category" placeholder="Categoria"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.category.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.situation_ok }">
          <mat-select [formControl]="memberFormSBCCV.controls.situation">
            <mat-option *ngFor="let sit of situations" [value]="sit.value">
              {{ sit.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="memberFormSBCCV.controls.situation.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.email_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.email" placeholder="Email"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.email.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.email2_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.email2" placeholder="Email2"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.email2.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.gender_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.sex" placeholder="Gênero"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.sex.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.filiationDate_ok }">
          <input matInput [matDatepicker]="pickerFiliationSBCCV" placeholder="Data Filiação"
            [formControl]="memberFormSBCCV.controls.dateFiliation">
          <mat-datepicker-toggle matSuffix [for]="pickerFiliationSBCCV"></mat-datepicker-toggle>
          <mat-datepicker #pickerFiliationSBCCV></mat-datepicker>
          <mat-error *ngIf="memberFormSBCCV.controls.dateFiliation.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.birthDate_ok }">
          <input matInput [matDatepicker]="pickerBirthSBCCV" placeholder="Data Nasc"
            [formControl]="memberFormSBCCV.controls.dateBirth">
          <mat-datepicker-toggle matSuffix [for]="pickerBirthSBCCV"></mat-datepicker-toggle>
          <mat-datepicker #pickerBirthSBCCV></mat-datepicker>
          <mat-error *ngIf="memberFormSBCCV.controls.dateBirth.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.titleDate_ok }">
          <input matInput [matDatepicker]="pickerTitleSBCCV" placeholder="Data Titulo"
            [formControl]="memberFormSBCCV.controls.dateTitle">
          <mat-datepicker-toggle matSuffix [for]="pickerTitleSBCCV"></mat-datepicker-toggle>
          <mat-datepicker #pickerTitleSBCCV></mat-datepicker>
          <mat-error *ngIf="memberFormSBCCV.controls.dateTitle.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.cpf_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.cpf" placeholder="CPF" autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.cpf.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.rg_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.rg" placeholder="RG" autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.rg.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.crm_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.crm" placeholder="CRM" autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.crm.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.cellPhone_ok }">
          <input readonly matInput type="text" [formControl]="memberFormSBCCV.controls.cellPhone" placeholder="Celular"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.cellPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.faxPhone_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.faxPhone" placeholder="FAX"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.faxPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.clinicPhone_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.clinicPhone" placeholder="Clínica"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.clinicPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.hospitalPhone_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.hospitalPhone" placeholder="Hospital"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.hospitalPhone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.auxPhone1_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.aux1Phone" placeholder="Auxiliar 1"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.aux1Phone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.auxPhone2_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.aux2Phone" placeholder="Auxiliar 2"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.aux2Phone.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.regional_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.regional" placeholder="regional"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.regional.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.state_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.state" placeholder="Estado"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.state.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.city_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.city" placeholder="Cidade"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.city.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.district_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.district" placeholder="Bairro"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.district.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.address_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.address" placeholder="Rua/Av"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.address.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.number_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.number" placeholder="Número"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.number.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.complement_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.complement" placeholder="Complemento"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.complement.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.postalCode_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.postalCode" placeholder="CEP"
            autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.postalCode.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.institute_ok }">
          <input matInput type="text" [formControl]="memberFormSBCCV.controls.resident_institute"
            placeholder="Residência" autocomplete="off">
          <mat-error *ngIf="memberFormSBCCV.controls.resident_institute.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.institute_begin_ok }">
          <input matInput [matDatepicker]="pickerResidentBegin" placeholder="Início"
            [formControl]="memberFormSBCCV.controls.resident_begin">
          <mat-datepicker-toggle matSuffix [for]="pickerResidentBegin"></mat-datepicker-toggle>
          <mat-datepicker #pickerResidentBegin></mat-datepicker>
          <mat-error *ngIf="memberFormSBCCV.controls.resident_begin.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" [ngClass]="{'full-width-red': !memberGN1.institute_end_ok }">
          <input matInput [matDatepicker]="pickerResidentEnd" placeholder="Término"
            [formControl]="memberFormSBCCV.controls.resident_end">
          <mat-datepicker-toggle matSuffix [for]="pickerResidentEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerResidentEnd></mat-datepicker>
          <mat-error *ngIf="memberFormSBCCV.controls.resident_end.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <div class="actions" *ngIf="memberFormSBCCV">
          <button mat-raised-button (click)="matDialogRef.close(['okSBCCV',memberFormSBCCV])"
            [disabled]="memberFormSBCCV.invalid">
            SBCCV <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </div>

    </div>

  </div>